module.exports = __webpack_public_path__ + "static/media/fast.ec34ffd6.svg";